/* Which InPrint modules are open. Paul 2026-09-26: Plan is marked Later like
 * Content and cannot be reached, though its screens and data stay built. Turning
 * it back on is this one flag; the issue home door and the /plan address both
 * read it. Tests that exercise the Plan screen set it true for their file. */
export const moduleOpen = { plan: false };
